import {
    LANDING_CONTACT_COMPANY,
    LANDING_CONTACT_EMAIL,
    LANDING_CONTACT_INN,
    LANDING_CONTACT_LEGAL_NAME,
    LANDING_CONTACT_OGRNIP,
    LANDING_CONTACT_PHONE,
    LANDING_CONTACT_WEBSITE,
} from '@/constants/landing/contact';
import { AppRoute } from '@/constants/routes';

export type LandingContactDetails = {
    company: string;
    email: string;
    inn: string;
    legalName: string;
    ogrnip: string;
    pagePath: AppRoute.Contacts;
    phone: string;
    website: string;
};

export type LandingContactRequisiteKey = 'legalName' | 'inn' | 'ogrnip' | 'website' | 'email' | 'phone';

export type LandingContactRequisite = {
    key: LandingContactRequisiteKey;
    value: string;
};

const LANDING_CONTACT_DETAILS: LandingContactDetails = {
    company: LANDING_CONTACT_COMPANY,
    email: LANDING_CONTACT_EMAIL,
    inn: LANDING_CONTACT_INN,
    legalName: LANDING_CONTACT_LEGAL_NAME,
    ogrnip: LANDING_CONTACT_OGRNIP,
    pagePath: AppRoute.Contacts,
    phone: LANDING_CONTACT_PHONE,
    website: LANDING_CONTACT_WEBSITE,
};

const LANDING_CONTACT_REQUISITES: LandingContactRequisite[] = [
    { key: 'legalName', value: LANDING_CONTACT_DETAILS.legalName },
    { key: 'inn', value: LANDING_CONTACT_DETAILS.inn },
    { key: 'ogrnip', value: LANDING_CONTACT_DETAILS.ogrnip },
    { key: 'website', value: LANDING_CONTACT_DETAILS.website },
    { key: 'email', value: LANDING_CONTACT_DETAILS.email },
    { key: 'phone', value: LANDING_CONTACT_DETAILS.phone },
];

export const getLandingContactDetails = (): LandingContactDetails => LANDING_CONTACT_DETAILS;

export const getLandingContactRequisites = (): LandingContactRequisite[] => LANDING_CONTACT_REQUISITES;
